/**
 * DiscountCampaignErrorModalCtrl controller
 *
 * @class DiscountCampaignErrorModalCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin*
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:DiscountCampaignErrorModalCtr
 */

/* @ngInject */
export default function DiscountCampaignErrorModalCtrl ($uibModalInstance, DiscountCampaign, Subscription, currentSubscriptions, activate, expire, dc, networkId, newSubscriptions) {
  const vm = this
  vm.currentSubscriptions = currentSubscriptions
  vm.newSubscriptions = newSubscriptions
  vm.activate = activate
  vm.expire = expire
  vm.dc = dc
  vm.update = !activate && !expire

  vm.mapNewSubscriptions = function (subscriptions) {
    vm.newSubscriptions.forEach(s => {
      const currentSubscription = subscriptions.find(sub => sub.id === s.id)
      if (currentSubscription) {
        s.autoPay = currentSubscription.autoPay
        s.free = currentSubscription.free
        s.enabled = currentSubscription.enabled
      } else {
        s.deleted = true
      }
    })
  }

  vm.mapSubscriptionsToError = function () {
    vm.autoPayError = false
    vm.enabledError = false
    vm.freeError = false
    vm.deletedError = false
    vm.deletedErrorSubscriptions = []
    vm.autoPayErrorSubscriptions = []
    vm.freeErrorSubscriptions = []
    vm.enabledErrorSubscriptions = []
    vm.currentSubscriptions.forEach(s => {
      if (vm.dc.status !== 'ACTIVE') {
        if (vm.dc.applyToRecurringPayments && !s.autoPay && !s.deleted) {
          vm.autoPayError = true
          vm.autoPayErrorSubscriptions.push(new Subscription({ ...s, networkId }))
        }
        if (!s.enabled && !s.deleted) {
          vm.enabledError = true
          vm.enabledErrorSubscriptions.push(new Subscription({ ...s, networkId }))
        }
        if (s.free) {
          vm.freeError = true
          vm.freeErrorSubscriptions.push(new Subscription({ ...s, networkId }))
        }
        if (s.deleted) {
          vm.deletedError = true
          vm.deletedErrorSubscriptions.push(new Subscription({ ...s, networkId }))
        }
      }
    })

    vm.newSubscriptions.forEach(s => {
      if (vm.dc.applyToRecurringPayments && !s.autoPay && !s.deleted) {
        vm.autoPayError = true
        vm.autoPayErrorSubscriptions.push(new Subscription({ ...s, networkId }))
      }
      if (!s.enabled && !s.deleted) {
        vm.enabledError = true
        vm.enabledErrorSubscriptions.push(new Subscription({ ...s, networkId }))
      }
      if (s.free) {
        vm.freeError = true
        vm.freeErrorSubscriptions.push(new Subscription({ ...s, networkId }))
      }
      if (s.deleted) {
        vm.deletedError = true
        vm.deletedErrorSubscriptions.push(new Subscription({ ...s, networkId }))
      }
    })
    vm.subscriptionsError = vm.deletedError || vm.freeError || vm.enabledError || vm.autoPayError
  }

  vm.mapSubscriptionsToError()

  vm.validateChanges = function () {
    vm.subscriptionsPromises = []
    if (vm.currentSubscriptions.length) {
      vm.subscriptionsPromises.push(DiscountCampaign.load({ id: dc.id, networkId }).then(({ subscriptions }) => subscriptions))
    }
    if (vm.newSubscriptions.length) {
      vm.subscriptionsPromises.push(Subscription.loadAll({ networkId })
        .then(data => data.filter(item => item.subscriptionType === 'Subscription'))
      )
    }
    Promise.all(vm.subscriptionsPromises).then((res) => {
      if (vm.currentSubscriptions.length && vm.newSubscriptions.length) {
        vm.currentSubscriptions = res[0]
        vm.mapNewSubscriptions(res[1])
      }
      if (vm.currentSubscriptions.length && !vm.newSubscriptions.length) {
        vm.currentSubscriptions = res[0]
      }
      if (vm.newSubscriptions.length && !vm.currentSubscriptions.length) {
        vm.mapNewSubscriptions(res[0])
      }
      vm.mapSubscriptionsToError()
      if (!vm.subscriptionsError && vm.update) {
        $uibModalInstance.dismiss()
      }
    })
  }

  vm.displayJoiner = function (index, length) {
    return index < length - 1 ? ', ' : ''
  }

  vm.dismiss = $uibModalInstance.dismiss

  vm.close = $uibModalInstance.close
}
